/*
 * File: utilities.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on July 21, 2022 at 10:51 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: March 14, 2025 at 12:17 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Constants
import { AVAILABLE_LOCALES } from '../Constants';


/**
 * Utilities
 */

// eslint-disable-next-line no-promise-executor-return
export const timeout = (ms) => new Promise((res) => setTimeout(res, ms));

export const getCDNURL = (merchant) => {

	// If development, use env variable
	if (process.env.ENV === 'development') {
		return process.env.CDN_URL;
	}

	// Create merchant domain
	let merchantDomain = `https://${merchant.domain}`;
	if (merchant.redirectToSubdomain) {
		merchantDomain = `https://${merchant.redirectToSubdomain}.${merchant.domain}`;
	}

	// Return merchant domain
	return merchantDomain;
};


/**
 * Parsers
 */

export const parseFirstLastName = (name) => {
	if (!name) return {};
	const nameArray = name.split(/\s+/);
	const firstName = nameArray[0].trim();
	const lastName = name.replace(firstName, '').trim();
	return { firstName, lastName };
};

export const reduceToBaseURL = (p) => {
	let path = p;
	if (path && typeof path === 'string') {
		AVAILABLE_LOCALES.forEach((locale) => {
			const testArray = path.split(locale);
			if (testArray.length > 1 && testArray[0] === '/') {
				const testPath = testArray[1];
				if ((testPath.length === 0 || testPath.charAt(0) === '/' || testPath.charAt(0) === '?')) {
					path = path.replace(locale, '').replace('//', '/');
				}
			}
		});
	}
	return path;
};
